import React, { Component } from 'react';


export default class extends Component {
	render() {        
		return (			
			<div className="container mt-4">
				<div className="row">
					<div className="col-12">
                        {this.props.children}
                    </div>
                </div>
            </div>
		);		
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/components/Col12.js